export const BROADBAND_ICON_TITLE = {
  'good-broadband': (speedInMbps, updateTimeInSec) =>
    `Internet Speed is more than the minimum requirement for taking this <%= productTypeSmall %> (4Mbps).\n${
      speedInMbps ? `${speedInMbps} Mbps` : ''
    } (updated ${updateTimeInSec} ${updateTimeInSec > 1 ? 'secs' : 'sec'} ago)`,
  'bad-broadband': (speedInMbps, updateTimeInSec) =>
    `Internet Speed is less than the minimum requirement for taking this <%= productTypeSmall %> (4Mbps).\n${
      speedInMbps ? `${speedInMbps} Mbps` : ''
    } (updated ${updateTimeInSec} ${updateTimeInSec > 1 ? 'secs' : 'sec'} ago)`,
  'no-broadband': () =>
    'You are offline. Please connect to a stable  internet to continue taking the <%= productTypeSmall %>.',
};

export default { BROADBAND_ICON_TITLE };
